export const getStyles = () => ({
  locationTargetGridRow: {
    fontSize: '12px',
    lineHeight: '19px',
    color: '#323130',
    whiteSpace: 'normal',

    '& .location-target-error': {
      color: '#a80000',
      fontSize: '12px',
      lineHeight: '16px',
      marginLeft: '16px',
      marginTop: '4px',
    },

    '& button.edit-location-target': {
      fontSize: '14px',
      lineHeight: '19px',
      color: '#007daa',
      fontWeight: 600,
      height: 'auto',
      padding: 0,
      border: 0,
      marginTop: '-1px',
    },

    '& .targeting-description-text': {
      fontSize: '14px',
      fontWeight: 600,
      color: '#323130',
    },

    '& .location-icon': {
      color: '#107c10',
      marginRight: '4px',
    },

    '& .negative-location-icon': {
      color: '#cf2837',
      marginRight: '4px',
    },
  },
  announceArea: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: '0',
  },
});
